<template>
	<div class="accounter">
		<TableBlock
			ref="PubTable"
			:action="action"
			:columns="columns"
			:param="params"
			:topWidth="30" 
			:navHeight="487" :topHegiht="350"
			@checkVal="selectionChange"
		>
		<div class="common-items-center common-space-between" style="margin-bottom: 16px;">
               <div class="common-items-center"> 
                  <el-input style="margin-right: 10px;width: 300px;" placeholder="联动名称" v-model="params.name"></el-input>
                  <el-button type="primary"  @click="serachBtn">查询</el-button>
                  <el-button   @click="resetBtn">重置</el-button>
               </div>
               <div>
               <el-button type="primary" class="add-btn" @click="exportFile" style="padding:10px">导出</el-button>
              </div>
      </div>
		</TableBlock>
		<setup ref="setup"></setup>
	</div>
</template>

<script>
	import { columns } from './linkage_police.js';
	import { operate } from '@/utils/config';
	import {postFun } from '@/utils/httpFun'
  import add from './block_linkage_add.vue'
  import setup from './block_linkage_setup.vue'
	import {Master,Subtabulation} from './serve/deviceServe'

	export default {
		components: {
			setup
		},
    props:{
      edits:{
        type:Object,
        default:()=>{}
      }
    },
		data() {
			return {
				action: operate.GETDEVLINKAGEPAGE,
				params: {
					name: ''
				},
				columns: [],
				selections: [],
				areaOptions: [],
				fullAreaAdress: '',
				master:{},
				selectAll:[]
			}
		},

		created() {
			this.master = new Master(this,this.edits);
			this.columns = columns(this);
			console.log('edis',this.edits);
			this.params.projectId = this.edits.id;
			let obj = {};
			new Promise(resolve=>{
				this.$bus.$on('top-getMess',obj,resolve);
			}).then(value=>{
				console.log("OBJECT",obj)
			})
		},

		methods: {
			exportFile(){

				if(this.selectAll.length == 0){
					this.$message.warning('请选择联动');
					return;
				}

				console.log('============',this.selectAll);

				let ids = this.selectAll.map(item=>item.id);

				this.master.exportMessage(ids);
			},
			resetBtn(){
				this.params.name = '';
				this.master.getHomeList();
			},
			serachBtn(){
				// this.$refs.PubTable.getDatas();
				this.master.getHomeList();
			},
      add(){
        alert('增加')
      },
      operateShow(index,item){
    
				let subtabulation = new Subtabulation(item.id);

        if(index == 0){
          // 编辑
          this.$refs.setup.open({
						operator:'setup'
					});
        }else if(index == 1){
          // 查看
          this.$refs.setup.open({
						operator:'query'
					},subtabulation);
        }else if(index == 2){
          this.$confirm('您确定要移除选中的数据?, 是否继续?', '删除', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
							let param = {
								id:item.projectSubId,
								projectId: this.edits.id
							}
							console.log("删除",param)
              await postFun(`${api.other}/project/removeMember`,param,res=>{
								if(res.data){
									this.$message.success("删除成功");
								}else{
									this.$message.warning("网络繁忙")
								}
								this.reset()
							})
            })
        }
      },
			search() {
				// if (!this.params.enabled && !this.params.keyWord.trim()) return;
				this.$refs.PubTable.search(this.params);
			},
			reset() {
				this.params.keyWord = '';
				this.$refs.PubTable.search(this.params);
				console.log("params ",this.params)
			},
      selectionChange(e){
        console.log('表格选择',e);
				this.selectAll = e;
      }
		}
	}
</script>

<style lang="scss" scoped>
	.form-search {
		display: flex;
		justify-content: space-between;
		// align-items: center;
	}
	::v-deep .search{
		margin-bottom: 0;
	}
</style>
